import TourPage from "@/components/TourPage";

export default function MurchisonFalls3Day() {
  return (
    <TourPage
      tourId="uganda/murchison-falls-3-day"
      title="3-Day Murchison Falls Adventure Safari"
      duration="3 Days / 2 Nights"
      price="$750 per person"
      image="https://images.unsplash.com/photo-1671360788724-100050645e10"
      description="Experience the magnificent Murchison Falls National Park, home to diverse wildlife and the world's most powerful waterfall. This 3-day safari adventure offers game drives, a boat cruise along the Nile, and a visit to the top of the falls."
      mapData={{
        center: [32.0, 1.3],
        zoom: 7,
        points: [
          { coordinates: [32.44, 0.04], label: "Entebbe International Airport", variant: 'airport' },
          { coordinates: [32.58, 0.34], label: "Kampala City", variant: 'city' },
          { coordinates: [32.07, 1.48], label: "Ziwa Rhino Sanctuary", variant: 'park' },
          { coordinates: [31.85, 2.25], label: "Murchison Falls National Park", variant: 'park' }
        ],
        route: [
          [32.44, 0.04], [32.48, 0.10], [32.52, 0.20], [32.58, 0.34], // Entebbe to Kampala
          [32.60, 0.45], [32.62, 0.60], [32.55, 0.85], [32.50, 1.05], // Kampala to Luwero
          [32.45, 1.30], [32.35, 1.45], [32.07, 1.48],               // Luwero to Ziwa
          [32.00, 1.65], [31.95, 1.85], [31.90, 2.05], [31.85, 2.25]  // Ziwa to Murchison Falls
        ]
      }}
      itinerary={[
        {
          day: 1,
          title: "Kampala to Murchison Falls National Park",
          description: "Early morning departure from Kampala to Murchison Falls National Park.",
          activities: [
            "Morning departure from Kampala",
            "Drive through scenic landscapes",
            "Stop at Ziwa Rhino Sanctuary",
            "Lunch en route",
            "Evening arrival at the lodge",
            "Dinner and overnight stay"
          ],
          accommodation: "Paraa Safari Lodge or similar",
          meals: "Lunch, Dinner"
        },
        {
          day: 2,
          title: "Game Drive & Nile Boat Cruise",
          description: "Full day of wildlife viewing and boat cruise to the falls base.",
          activities: [
            "Early morning game drive",
            "Spot lions, elephants, giraffes, and more",
            "Afternoon boat cruise to the falls",
            "Bird watching",
            "Evening game drive",
            "Dinner and overnight"
          ],
          accommodation: "Paraa Safari Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Top of the Falls & Return to Kampala",
          description: "Visit the top of the falls and return to Kampala.",
          activities: [
            "Morning visit to the top of the falls",
            "Photography session",
            "Drive back to Kampala",
            "Stop for lunch en route",
            "Evening arrival in Kampala"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "Park entrance fees",
        "Transportation in a 4x4 safari vehicle",
        "English-speaking guide/driver",
        "Boat cruise fees",
        "Accommodation as per itinerary",
        "Meals as specified",
        "Bottled water",
        "Game drives"
      ]}
      exclusions={[
        "International flights",
        "Visa fees",
        "Travel insurance",
        "Personal items",
        "Tips and gratuities",
        "Drinks and beverages",
        "Optional activities not mentioned in the itinerary"
      ]}
    />
  );
}